//import Box from "@mui/material/Box";
//import LoadingButton from "@mui/lab/LoadingButton";
//import Button from "@mui/material/Button";
//import Divider from "@mui/material/Divider";
//import Paper from "@mui/material/Paper";
//import Step from "@mui/material/Step";
//import StepContent from "@mui/material/StepContent";
//import StepLabel from "@mui/material/StepLabel";
//import Stepper from "@mui/material/Stepper";
//import TextField from "@mui/material/TextField";
//import Typography from "@mui/material/Typography";
//import * as React from "react";
//import { useDispatch, useSelector } from "react-redux";
//import {
//    registerAppUser,
//    validateEmail,
//    validateNumber,
//} from "../actions/authActions";
//import { getOperatingSystem } from "../actions/tool";
//import { IP } from "../config/IP";
//
//export default function VerticalLinearStepper() {
//    const dispatch = useDispatch();
//    const state = useSelector((state) => state);
//    const [activeStep, setActiveStep] = React.useState(
//        state.auth.App_RegistrationStep
//    );
//    const [error, setError] = React.useState({ email: "", token: "" });
//    const [data, setData] = React.useState({
//        type: "",
//        action: "",
//        url: IP.nodeServer + "api/authenticateApp",
//        email: "",
//        token: "",
//    });
//
//    const handleChange = (event) => {
//        setData({
//            ...data,
//            [event.target.name]: event.target.value ? event.target.value.trim() : "",
//        });
//    };
//    React.useEffect(() => {
//        console.log("RegisterApp useEffect data=", data);
//    }, [data, setData]);
//    React.useEffect(() => {
//        if (state.auth.app_is_token_saving_failed) {
//            console.log(
//                "RegisterApp useEffect state.auth.app_is_token_saving_failed=",
//                state.auth.app_is_token_saving_failed
//            );
//            if (state.auth.App_RegistrationStep === 1) {
//                setError({
//                    ...error,
//                    token: state.auth.appMessage,
//                });
//            }
//            else if (state.auth.App_RegistrationStep === 0) {
//                setError({
//                    ...error,
//                    email: state.auth.appMessage,
//                });
//            }
//        } else {
//            setError({
//                ...error,
//                token: "",
//            });
//        }
//    }, [state.auth.app_is_token_saving_failed]);
//    const steps = [
//        {
//            label: "Put your email",
//            description: "validate with your email",
//            content: (
//                <TextField
//                    id="email"
//                    name="email"
//                    label="email"
//                    value={data.email}
//                    variant="outlined"
//                    onChange={handleChange}
//                    onKeyDown={(e) => {
//                        if (e.key === "Enter") {
//                            handleNext();
//                        }
//                    }}
//                    error={error.email !== ""}
//                    helperText={error.email !== "" ? error.email : ""}
//                    sx={{
//                        "& .MuiInputBase-input ": { padding: 2 },
//                    }}
//                />
//            ),
//        },
//        {
//            label: "One Time Password",
//            description: "the OTP was sent to your email,Please put it here",
//            content: (
//                <TextField
//                    id="token"
//                    name="token"
//                    label="OTP"
//                    value={data.token}
//                    variant="outlined"
//                    onChange={handleChange}
//                    onKeyDown={(e) => {
//                        if (e.key === "Enter") {
//                            handleNext();
//                        }
//                    }}
//                    error={error.token !== ""}
//                    helperText={error.token !== "" ? error.token : ""}
//                    sx={{
//                        "& .MuiInputBase-input ": { padding: 2 },
//                    }}
//                />
//            ),
//        },
//    ];
//    const handleNext = () => {
//        // Get the visitor identifier when you need it.
//
//        let id = localStorage.getItem("sessionId");
//        let os = getOperatingSystem(window);
//        if (activeStep === 0) {
//            if (validateEmail(data.email)) {
//                setError({ ...error, email: "" });
//                let input = {
//                    ...data,
//                    type: "save_email",
//                    action: "createOTP",
//                    url: IP.nodeServer + "api/authenticateApp",
//
//                    deviceInfo: {
//                        id: id,
//                        manufacturer: os,
//                        brand: os,
//                        buildId: "",
//                    },
//                    email: data.email,
//                };
//                console.log("RegisterApp handleNext input=", input);
//                dispatch(registerAppUser(input));
//            } else {
//                console.log("RegisterApp handleNext email error");
//                setError({
//                    ...error,
//                    email:
//                        data.email === "" ? "Email is Empty" : "Please Enter a valid email",
//                });
//            }
//        } else if (activeStep === 1) {
//            console.log("RegisterApp data.token=", data.token);
//
//            if (validateNumber(data.token)) {
//                if (data.token.length === 6) {
//                    setError({ ...error, token: "" });
//                    dispatch(
//                        registerAppUser({
//                            type: "confirm_otp",
//                            action: "verifyOTP",
//                            url: IP.nodeServer + "api/authenticateApp",
//                            email: state.auth.app_user.email,
//                            token: data.token,
//                        })
//                    );
//                } else {
//                    setError({ ...error, token: "The otp should have size of 6 digit" });
//                }
//            } else {
//                setError({ ...error, token: "The otp should only be digits" });
//            }
//        }
//        //setActiveStep((prevActiveStep) => prevActiveStep + 1);
//    };
//
//    const handleBack = () => {
//        setActiveStep((prevActiveStep) => prevActiveStep - 1);
//    };
//
//    const handleReset = () => {
//        setActiveStep(0);
//    };
//    React.useEffect(() => {
//        console.log(
//            "RegisterApp state.auth.App_RegistrationStep=",
//            state.auth.App_RegistrationStep
//        );
//        setActiveStep(state.auth.App_RegistrationStep);
//    }, [state.auth.App_RegistrationStep]);
//
//    return (
//        <Box sx={{ maxWidth: 400 }}>
//            <Divider />
//            <h5>Authentication</h5>
//            <Stepper activeStep={activeStep} orientation="horizontal">
//                {steps.map((step, index) => (
//                    <Step key={step.label}>
//                        <StepLabel
//                            optional={
//                                index === 2 ? (
//                                    <Typography variant="caption">Last step</Typography>
//                                ) : null
//                            }
//                        >
//                            {step.label}
//                        </StepLabel>
//                        <StepContent>
//                            <Typography>{step.description}</Typography>
//                            <Box sx={{ mt: 2 }}>
//                                <div>{step.content}</div>
//
//                                <div>
//                                    <LoadingButton
//                                        variant="contained"
//                                        size="contained"
//                                        loading={state.auth.app_is_registering}
//                                        disabled={state.auth.app_is_registering}
//                                        onClick={handleNext}
//                                        sx={{
//                                            "& .MuiButtonBase-root ": { padding: 2 },
//                                        }}
//                                    >
//                                        {index === steps.length - 1 ? "Finish" : "Continue"}
//                                    </LoadingButton>
//                                    <Button
//                                        variant="contained"
//                                        size="contained"
//                                        disabled={index === 0 || state.auth.app_is_registering}
//                                        onClick={handleBack}
//                                        sx={{
//                                            "& .MuiButtonBase-root ": { padding: 2 },
//                                        }}
//                                    >
//                                        Back
//                                    </Button>
//                                </div>
//                            </Box>
//                        </StepContent>
//                    </Step>
//                ))}
//            </Stepper>
//            {activeStep === steps.length && (
//                <Paper square elevation={0} sx={{ p: 3 }}>
//                    <Typography>All steps completed - you&apos;re finished</Typography>
//                    <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
//                        Reset
//                    </Button>
//                </Paper>
//            )}
//        </Box>
//    );
//}
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import { Link } from "react-router-dom";
import LinearProgress from "@material-ui/core/LinearProgress";
import { green } from "@material-ui/core/colors";
import { useHistory } from "react-router-dom";
import logo from "../assets/images/white_logo.png";
import "./Login.css";
import { makeStyles } from "@material-ui/core/styles";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    registerAppUser,
    validateNumber,
} from "../actions/authActions";
import { getOperatingSystem } from "../actions/tool";
import { IP } from "../config/IP";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
        display: "flex",
        alignItems: "center",
    },
    wrapper: {
        margin: theme.spacing(1),
        position: "relative",
    },
    buttonSuccess: {
        backgroundColor: green[500],
        "&:hover": {
            backgroundColor: green[700],
        },
    },
    fabProgress: {
        color: green[500],
        position: "absolute",
        top: -6,
        left: -6,
        zIndex: 1,
    },
    buttonProgress: {
        color: green[500],
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
}));

export default function LoginWithOTP(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const state = useSelector((state) => state);
    console.log("LoginFormerStaff state=", state);
    const [error, setError] = React.useState({ token: "" });
    const token = localStorage.getItem("token");
    const [data, setData] = React.useState({
        type: "",
        action: "",
        url: IP.nodeServer + "api/authenticateApp",
        token: "",
    });

    const handleChange = (event) => {
        setData({
            ...data,
            [event.target.name]: event.target.value ? event.target.value.trim() : "",
        });
    };
    React.useEffect(() => {
        console.log("RegisterApp useEffect data=", data);
    }, [data, setData]);
    React.useEffect(() => {
        if (state?.auth?.app_is_token_saving_failed) {
            console.log(
                "RegisterApp useEffect state?.auth?.app_is_token_saving_failed=",
                state?.auth?.app_is_token_saving_failed
            );
            if (state?.auth?.App_RegistrationStep === 1) {
                setError({
                    ...error,
                    token: state?.auth?.appMessage,
                });
            }
        } else {
            setError({
                ...error,
                token: "",
            });
        }
    }, [state?.auth?.app_is_token_saving_failed]);

    const handleNext = () => {
        // Get the visitor identifier when you need it.

        let id = localStorage.getItem("sessionId");
        let os = getOperatingSystem(window);
        console.log("RegisterApp data.token=", data.token);
        if (validateNumber(data.token)) {
            if (data.token.length === 6) {
                setError({ ...error, token: "" });
                dispatch(
                    registerAppUser({
                        type: "confirm_otp",
                        action: "verifyOTP",
                        url: IP.nodeServer + "api/authenticateApp",
                        email: state?.auth?.app_user.email,
                        token: data.token,
                    })
                );
            } else {
                setError({ ...error, token: "The otp should have size of 6 digit" });
            }
        } else {
            setError({ ...error, token: "The otp should only be digits" });
        }
    };

    // const handleReset = () => {
    //     setActiveStep(0);
    // };
    React.useEffect(() => {
        if (state?.auth?.isAuthenticated) {
            window.location.href = "/";
        }
    }, [state?.auth?.isAuthenticated]);

    return (
        <div className="auth">
            <div className={classes.root}>

                <div className="login">
                    {/* <Tabs value={value} onChange={handleChangeTab} aria-label="disabled tabs example">
                        <Tab label="Active Eligible Staff" />
                        <Tab label="Inactive Eligible former Staff" />
                    </Tabs> */}
                    {/* <div className="login-triangle"></div> */}

                    {/* <h2 className="login-header">Log in</h2> */}
                    <img src={logo} alt="RwandAir Logo" className="login-logo" />
                    <form className="login-container">
                        <span className="login-heading">RwandAir MyWork System</span>
						<span className="login-subheading">Enter the code received on your email to access My work application</span>
                        <span className="personal-email-label">One Time Password</span>
                        <TextField
                            id="token"
                            name="token"
                            className="otp-code"
                            placeholder="Enter OTP (6 digits)"
                            value={data.token}
                            variant="outlined"
                            onChange={handleChange}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleNext();
                                }
                            }}
                            error={error.token !== ""}
                            helperText={error.token !== "" ? error.token : ""}
                            style={{ width: "90%", padding: 0, marginLeft: "18px" }}
                            inputProps={{ style: { padding: 16 } }}
                        />
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center"  }}>
                            <Button
                                variant="contained"
                                className="continue-button"
                                disabled={state?.auth?.app_is_registering}
                                onClick={handleNext}
                                style={{ margin: "30px auto 10px auto" }}
                            >
                                {state?.auth?.app_is_registering ? <CircularProgress size={22} /> : "Submit"}
                            </Button>
                        </div>

                        <Link className="login-link" to="/">Back to Login?</Link>
                        {/* <Stepper activeStep={activeStep} orientation="horizontal">
                            {steps.map((step, index) => (
                                <Step key={step.label}>
                                    <StepLabel
                                        optional={
                                            index === 2 ? (
                                                <Typography variant="caption">Last step</Typography>
                                            ) : null
                                        }
                                    >
                                        {step.label}
                                    </StepLabel>
                                    <StepContent>
                                        <Typography>{step.description}</Typography>
                                        <Box sx={{ mt: 2 }}>
                                            <div>{step.content}</div>

                                            <div>
                                                <LoadingButton
                                                    variant="contained"
                                                    size="contained"
                                                    loading={state?.auth?.app_is_registering}
                                                    disabled={state?.auth?.app_is_registering}
                                                    onClick={handleNext}
                                                    sx={{
                                                        "& .MuiButtonBase-root ": { padding: 2 },
                                                    }}
                                                >
                                                    {index === steps.length - 1 ? "Finish" : "Continue"}
                                                </LoadingButton>
                                                <Button
                                                    variant="contained"
                                                    size="contained"
                                                    disabled={index === 0 || state?.auth?.app_is_registering}
                                                    onClick={handleBack}
                                                    sx={{
                                                        "& .MuiButtonBase-root ": { padding: 2 },
                                                    }}
                                                >
                                                    Back
                                                </Button>
                                            </div>
                                        </Box>
                                    </StepContent>
                                </Step>
                            ))}
                        </Stepper> */}
                    </form>
                    <div style={{ color: 'red' }} >{props.state?.auth?.errorappMessage ? props.state?.auth?.errorappMessage : ""}
                        {props.state?.auth?.isLoading ? <LinearProgress variant="query" /> : ""}
                    </div>
                </div>
            </div>
        </div>
        
    );
}
